import { render } from "./FiscalNotification.vue?vue&type=template&id=63482eb4&scoped=true"
import script from "./FiscalNotification.vue?vue&type=script&lang=js"
export * from "./FiscalNotification.vue?vue&type=script&lang=js"

import "./FiscalNotification.vue?vue&type=style&index=0&id=63482eb4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63482eb4"]])

export default __exports__